import logo from './bebelLooping.png';
export const Loading = () => {
  return (
    <div className='flex h-screen w-full flex-col items-center justify-center fixed'>
      <div className='mb-8 animate-bounce'>
        <img src={logo} alt='Aguarde carregando...' />
      </div>
    </div>
  );
};

export default Loading as React.FC;
